import React from "react";
import { motion } from "framer-motion";
import { Overline } from "./primitives";
import { WHO_NOT_FOR } from "./content";

const EASE = [0.16, 1, 0.3, 1];

export default function WhoNotFor() {
  return (
    <section data-testid="who-not-for-section" className="relative bg-charcoal py-28 text-warm md:py-40">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: EASE }}
        >
          <Overline className="text-copper">And Who It Is Not</Overline>
        </motion.div>

        <div className="mt-14 md:mt-20">
          {WHO_NOT_FOR.map((line, i) => (
            <motion.p
              key={i}
              initial={{ opacity: 0.15, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.6 }}
              transition={{ duration: 0.9, ease: EASE }}
              className="border-t border-warm/10 py-7 font-serif text-3xl leading-tight text-warm/90 sm:text-5xl lg:text-6xl"
            >
              {line}
            </motion.p>
          ))}
        </div>

        <p className="mt-16 max-w-[46ch] leading-relaxed text-warm/45">
          Exclusivity is not a posture. It is the only way to protect the depth of attention
          each legacy deserves.
        </p>
      </div>
    </section>
  );
}
